import { render, staticRenderFns } from "./address-select.app.vue?vue&type=template&id=48f19afc&"
import script from "./address-select.app.vue?vue&type=script&lang=js&"
export * from "./address-select.app.vue?vue&type=script&lang=js&"
import style0 from "./address-select.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports